<template>
    <div class="radar-chart mx-auto mt-4 mb-4"></div>
</template>

<style scoped>
    .radar-chart {
        position: relative;
    }
</style>

<script>

import 'apexcharts/dist/apexcharts.css'
import ApexCharts from 'apexcharts'
import ChartLabels from './ChartLabels'
import ChartColors from './ChartColors'
import Icon from './Icon'

export default {

    props: {
        data: {
            type: Array,
            required: true,
        },
        factor: {
            type: String,
            required: true,
        },
        prefix: {
            type: String,
            default: () => 'MobilityIndex',
        },
        title: {
            type: String,
            default: () => 'Mobility Index'
        }
    },
    data() {
        return {
            chart: null,
            labels: ChartLabels,
        }
    },
    computed: {
        series() {
            const data = this.buildSeries(this.factor)
            return data
        }
    },
    watch: {
        factor(c) {
            // console.debug("UPDATE SERIES")
            this.chart.updateSeries(this.buildSeries(c))
            this.chart.updateOptions({colors: ChartColors[c]})
        }
    },
    mounted() {
        this.chart = new ApexCharts(this.$el, {
            chart: {
                type: 'radar',
                // width: 900,
                // height: 700,
                dropShadow: {
                    enabled: true,
                    blur: 1,
                    left: 1,
                    top: 1
                },
                toolbar: {
                    // https://apexcharts.com/docs/options/chart/toolbar/
                    show: true,
                    export: {
                        svg: {
                            filename: 'TRAFIG-mobility-indicators.svg'
                        }
                    }
                }
            },
            // https://apexcharts.com/docs/options/plotoptions/radar/
            plotOptions: {
                radar: {
                    size: 270,
                    polygons: {
                        strokeColor: '#e8e8e8',
                        fill: {
                            colors: ['#f8f8f8', '#fff']
                        }
                    }
                }
            },
            grid: {
                show: false,
                padding: {
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                }
            },
            colors: ChartColors[this.factor],
            title: {
                // text: this.title,
                align: 'center',
                style: {
                    fontSize: '1.5rem',
                    fontFamily: '"Roboto sans", sans',
                    fontWeight: 500,
                },
                offsetY: 15,
            },
            legend: {
                show: true,
                fontSize: '15ch'
            },
            stroke: {
                width: 2
            },
            fill: {
                opacity: 0.1
            },
            markers: {
                size: 5,
                hover: {
                    size: 10
                }
            },
            dataLabels: {
                // enabled: true
            },            
            xaxis: {
                categories: [
                    "Long-distance mobility",
                    "Internal mobility",
                    "Return mobility",
                    "Return intention",
                    "Onward move attempts",
                    "Onward move intention",
                    "Freedom to move on",
                    "Resettlement / Relocation"
                ],
                labels: {
                    style: {
                        colors: Array(8).fill("#666666"),
                        fontSize: "1rem",                
                    },
                },
            },
            yaxis: {
                // tickAmount: 5,
                min: 0,
                // max: 10,
                labels: {
                    formatter: (y) => y.toFixed(0)
                },
                /*tooltip: {
                    enabled: true,
                    offsetY: 50,
                    formatter: function() {
                        return "info text";  //How does this work?
                    }
                }*/
            },
            series: this.series,
            tooltip: {
                enabled: true, 
                followCursor: true,
                x: {
                    show: true
                },
                y: {
                    formatter: (y) => y.toFixed(1)
                }
            },
            annotations: {
                position: 'front',
                 /*
                 texts: [{
                    x: 0,
                    y: 800,
                    text: '© BICC 2022 CC-BY-NC-ND',
                    fontSize: '15px',
                    fontWeight: 'lighter',
                    foreColor: '#959DA2'
                    }],
                    */
                images: [{ path: Icon, 
                width: 200, height: 100, x: 0, y: 700}],
            }
        })
        this.chart.render()
    },
    unmounted() {
        this.chart.destroy()
        delete this.chart
    },
    methods: {
        buildSeries(factor) {
            // console.debug("SERIES", factor)

            const round = x => Math.round(x * 10) / 10

            const model = {}            
            for (const record of this.data) {
                const key = (factor == 'all') ? 'all' : record[factor]
                if (key === '..'  || key === '#NULL!') {
                    continue
                }
                if (!(key in model)) {
                    model[key] = {
                        name: this.labels[factor][key] ?? ('#' + key),
                        sums: Array(8).fill(0),
                        count: 0
                    }
                }
                model[key].count++
                for (let i = 0; i < 8; i++) {
                    const value = record[this.prefix + (i + 1)] ?? '..'
                    if (value === '..' || value === '#NULL!') {
                        continue
                    }
                    model[key].sums[i] += Number(value)
                }
            }
            for (const key in model) {
                const c = model[key].count
                model[key].data = model[key].sums.map(s => round(s / c))
                delete model[key].sums
                delete model[key].count
            }

            const series = []
            for (const k in model) {
                series.push(model[k])
            }

            // console.debug("series", series)
            return series
        }
    } 
}
</script>